var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeknionLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 47.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8a898a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "teknion-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.28,17.07H8.67V42.14a1.07,1.07,0,0,0,1.08,1.08h7.52v4.2H12.2a7.54,7.54,0,0,1-7.86-7.86V17.07H0v-4.2H4.34V0H8.67V12.87h8.6v4.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54,20.73v4.4A7.54,7.54,0,0,1,46.18,33H28v9.15a1.07,1.07,0,0,0,1.08,1.08H53.29v4.2H31.54a7.54,7.54,0,0,1-7.86-7.86V20.73a7.54,7.54,0,0,1,7.86-7.86H46.18A7.54,7.54,0,0,1,54,20.73ZM28,18.16V28.8h20.6a1.07,1.07,0,0,0,1.08-1.08V18.16a1.07,1.07,0,0,0-1.08-1.08H29.1A1.07,1.07,0,0,0,28,18.16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.65,30.69V47.43H61.31V0h4.34V26.49h5.69L84.69,12.87h6L75.07,28.59,91.8,47.43h-6L71.27,30.69H65.65Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.76,12.87a7.54,7.54,0,0,1,7.86,7.86v26.7h-4.34V18.16a1.07,1.07,0,0,0-1.08-1.08h-20.6V47.43H97.27V12.87h22.49Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140,0V6.37h-4.34V0H140Zm0,12.87V47.43h-4.34V12.87H140Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.64,39.57V20.73a7.54,7.54,0,0,1,7.86-7.86h14.64A7.54,7.54,0,0,1,178,20.73V39.57a7.54,7.54,0,0,1-7.86,7.86H155.5A7.54,7.54,0,0,1,147.64,39.57Zm24.93,3.66a1.07,1.07,0,0,0,1.08-1.08v-24a1.07,1.07,0,0,0-1.08-1.08H153.06A1.07,1.07,0,0,0,152,18.16v24a1.07,1.07,0,0,0,1.08,1.08h19.51Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.14,12.87A7.54,7.54,0,0,1,216,20.73v26.7h-4.34V18.16a1.07,1.07,0,0,0-1.08-1.08H190V47.43h-4.34V12.87h22.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeknionLogo);
export default __webpack_public_path__ + "static/media/teknion-logo.f33c4954f3adfea0d8103ee242d40b87.svg";
export { ForwardRef as ReactComponent };